export const getOrderListTab = (initialFilter = {}) => {
  const today = new Date().toISOString().split('T')[0];

  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate() + 1);
  const nextDayStr = nextDay.toISOString().split('T')[0];

  return {
    field: 'preset',
    isPreset: true,
    defaultTab: 'processing',
    tabs: [
      {
        key: 'processing',
        label: 'Processing',
        preset: {
          ...initialFilter,
          order_status: ['processing'],
        },
      },
      {
        key: 'cancelled',
        label: 'Cancelled',
        preset: {
          ...initialFilter,
          order_status: ['cancelled'],
          created_after: `${today}T05:30:00`,
          created_before: `${nextDayStr}T05:30:00`,
        },
      },
      {
        key: 'all',
        label: 'All',
        preset: {
          ...initialFilter,
          created_after: `${today}T05:30:00`,
          created_before: `${nextDayStr}T05:30:00`,
        },
      },
      {
        key: 'unfulfillable',
        label: 'Unfulfillable',
        preset: {
          ...initialFilter,
          order_status: ['unfulfillable'],
        },
      },
      {
        key: 'created',
        label: 'Created',
        preset: {
          ...initialFilter,
          order_status: ['created'],
        },
      },
    ],
  };
};
